import { InputRule } from "@handlewithcare/prosemirror-inputrules";
import { type NodeType } from "prosemirror-model";
import { TextSelection } from "prosemirror-state";

import { emitCodeBlockMeta } from "@moment/prosemirror-schema/src/lib/nodes/code_block";

import { getPreferredCodeBlockLanguage } from "../nodeViews/codeBlock/codeBlockLanguagePreference";

// Given a code block node type, returns an input rule that turns a
// textblock starting with three backticks into a code block.
export const codeBlockRule = (nodeType: NodeType): InputRule => {
	return new InputRule(/^```(\w+)?$/, (state, match, start, end) => {
		const $start = state.doc.resolve(start);
		if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) {
			return null;
		}

		let tr = state.tr;
		const language = match[1] || getPreferredCodeBlockLanguage();

		tr = state.tr.delete(start, end).setBlockType(start, start, nodeType, {
			language,
			meta: emitCodeBlockMeta({ lineNumbers: true, lineWrapping: false }),
		});

		tr = tr.setSelection(TextSelection.create(tr.doc, start));

		return tr;
	});
};
